import React, { useCallback } from 'react';
import { Close as RemoveIcon } from '@mui/icons-material';
import ResourceInputFields from './ResourceInputFields';
import { Card, CardContent } from '@mui/material';
import { NewReleases as NewReleasesIcon } from '@mui/icons-material';
import ConfirmDialog from '@shared/components/confirmDialog/ConfirmDialog';
import { useRemoveConfirmDialog } from '../hooks/useRemoveConfirmDialog';
import { useShownResources } from '../ResourceStore';
import { useShallow } from 'zustand/shallow';

/**
 * @typedef {object} EditResourceCardsProps
 * @property {Array<*>} formFields
 * @property {(index: number) => void} remove
 * @property {*} control
 */

/**
 * @param {EditResourceCardsProps} props
 */
const EditResourceCards = props => {
  const { formFields, control, remove } = props;

  const shownResources = useShownResources(useShallow(state => state.shownResources));

  const { isDialogOpen, openDialog, closeDialog, handleConfirm } = useRemoveConfirmDialog(remove);

  const fieldNameProvider = useCallback((fieldName, index) => {
    return `${fieldNamePrefix}.${index}.${fieldName}`;
  }, []);

  return (
    <>
      {shownResources.map(resource => {
        const formIndex = formFields.findIndex(x => x.resourceId === resource.resourceId);

        return (
          <Card key={resource.resourceId} role='edit-card'>
            <CardContent>
              <div className='edit-resource-form-fields'>
                <div className='form-icons'>
                  {resource.hasReleaseIcon && (
                    <NewReleasesIcon data-testid='releaseIcon' className='new-release' />
                  )}
                  <RemoveIcon
                    className='remove-resource-icon'
                    data-testid='remove-resource-icon'
                    onClick={() => openDialog(formIndex)}
                  />
                </div>
                <ResourceInputFields
                  control={control}
                  index={formIndex}
                  displayTitles={false}
                  fieldNameProvider={fieldNameProvider}
                />
              </div>
            </CardContent>
          </Card>
        );
      })}
      <ConfirmDialog
        open={isDialogOpen}
        handleClose={closeDialog}
        handleOnConfirm={handleConfirm}
        cancelBtnText={dialogCancelText}
        confirmBtnText={dialogConfirmText}
        message={dialogMessage}
      />
    </>
  );
};

const fieldNamePrefix = 'resources';
const dialogMessage = 'Are you sure you want to delete?';
const dialogCancelText = 'No';
const dialogConfirmText = 'Yes';

export default EditResourceCards;
